import React, { useState, useEffect } from 'react';
import { MultiSelect as ReactMultiSelect } from 'react-multi-select-component';
import '../../../styles/layout/forms/MultiSelect.css'

const MultiSelect = ({ value, onChange,options,labelledBy,label }) => {
    return (
        <div className="theme-multiselect">
            <label>{label}</label>
            <ReactMultiSelect className="theme-multiselect"
                options={options}
                value={value}
                onChange={onChange}
                labelledBy={labelledBy}
                />
        </div>
    )
}
export default MultiSelect

